function showProductMedia(gallery, id) {
  if (!gallery || !id) return;
  const target = [...gallery.querySelectorAll('[data-media-id]')].find(item => item.dataset.mediaId === String(id));
  if (!target) return;
  gallery.querySelectorAll('[data-media-id]').forEach(item => {
    const active = item === target;
    item.classList.toggle('is-active', active);
    if (!active) item.querySelectorAll('video').forEach(video => video.pause());
  });
  gallery.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
}
function initializeTheme(scope = document) {
  scope.querySelectorAll('[data-product-gallery]:not(.is-enhanced)').forEach(gallery => {
    const initial = gallery.querySelector('.is-active') || gallery.querySelector('[data-media-id]');
    if (!initial) return;
    showProductMedia(gallery, initial.dataset.mediaId);
    gallery.classList.add('is-enhanced');
  });
}
initializeTheme();
document.addEventListener('shopify:section:load', event => initializeTheme(event.target));
document.addEventListener('click', event => {
  const thumbnail = event.target.closest('[data-media-target]');
  if (thumbnail) {
    showProductMedia(thumbnail.closest('[data-product-gallery]'), thumbnail.dataset.mediaTarget);
    return;
  }
  const routeLink = event.target.closest('a[href="/#trips"], a[href="#trips"], a[href="/#roadbook"], a[href="#roadbook"]');
  if (!routeLink || location.pathname !== '/') return;
  const targetId = routeLink.getAttribute('href').split('#')[1];
  const target = document.getElementById(targetId);
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  window.history.replaceState(null, '', `#${targetId}`);
});
document.addEventListener('change', event => {
  const select = event.target;
  if (!select.matches('select[name="id"]')) return;
  const option = select.selectedOptions[0];
  if (!option) return;
  const form = select.closest('form');
  const status = form?.querySelector('[data-cart-status]');
  if (status) status.textContent = '';
  const section = select.closest('[data-product-section]');
  const price = section?.querySelector('[data-product-price]') || select.closest('.card')?.querySelector('[data-card-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (!section) return;
  const button = form?.querySelector('button[type="submit"]');
  const available = option.dataset.available === 'true';
  if (button) {
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  }
  showProductMedia(section.querySelector('[data-product-gallery]'), option.dataset.mediaId);
  const url = new URL(location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState(null, '', url);
});
document.addEventListener('submit', async event => {
  const form = event.target;
  // Newsletter success is shown only after Shopify accepts the submission.
  if (!form.matches('[data-quick-add]')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled || form.dataset.submitting === 'true') return;
  const originalLabel = button.textContent;
  const status = form.querySelector('[data-cart-status]');
  const viewCart = form.querySelector('[data-view-cart]');
  form.dataset.submitting = 'true';
  button.disabled = true;
  button.textContent = 'Adding…';
  if (status) status.textContent = '';
  if (viewCart) viewCart.hidden = true;
  const formUrl = new URL(form.action, location.origin);
  formUrl.pathname = formUrl.pathname.replace(/\/$/, '') + '.js';
  try {
    const response = await fetch(formUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please check your option and try again.');
    if (status) status.textContent = 'Added to your cart.';
    if (viewCart) viewCart.hidden = false;
    // A failed count refresh must never claim a successful cart addition failed.
    try {
      const cartLink = document.querySelector('.nav-cart');
      if (cartLink) {
        const cartResponse = await fetch(cartLink.getAttribute('href').replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          cartLink.textContent = `${cartLink.dataset.cartLabel || 'Cart'} · ${cart.item_count}`;
        }
      }
    } catch (_) { /* The item was already added; keep the success and cart link. */ }
  } catch (error) {
    if (status) status.textContent = error.message === 'Failed to fetch' ? 'Connection interrupted. Check your cart before trying again.' : error.message;
    if (viewCart) viewCart.hidden = false;
  } finally {
    form.dataset.submitting = 'false';
    button.disabled = false;
    button.textContent = originalLabel;
  }
});
